import { render } from "./userPerformanceMange.vue?vue&type=template&id=c8974024&scoped=true"
import script from "./userPerformanceMange.vue?vue&type=script&lang=js"
export * from "./userPerformanceMange.vue?vue&type=script&lang=js"

import "./userPerformanceMange.vue?vue&type=style&index=0&id=c8974024&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8974024"]])

export default __exports__